import { render, staticRenderFns } from "./PolicyFormRecordType.vue?vue&type=template&id=99f94a76&scoped=true&"
import script from "./PolicyFormRecordType.vue?vue&type=script&lang=ts&"
export * from "./PolicyFormRecordType.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyFormRecordType.vue?vue&type=style&index=0&id=99f94a76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f94a76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
